module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataReady) ? _c('div', {
    staticClass: "container page-container"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('h1', [_vm._v("Confirm new password")])])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-011f4401!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confirm.vue
// module id = 339
// module chunks = 2